<iframe [src]="safeUrl" frameborder="0" style="width: 100%; height: 100%; display: block;"  allowfullscreen>
</iframe>